import React from 'react'
import { Box, Grid } from '@mui/material'
import { backgroundThemes, themeColors } from '../../../common/constants/themeConstants'

export default function ThemeSelector({ onThemeChange, selectedTheme }) {
  return (
    <Grid container alignItems={'center'} columnGap={2}>
      {Object.entries(backgroundThemes).map(([themeId, theme]) => (
        <Grid item key={themeId}>
          <Box
            sx={{
              width: 36,
              height: 36,
              opacity: theme.isLight || themeId === selectedTheme ? 1 : 0.8,
              borderRadius: '50%',
              backgroundImage: theme.image ? `url(${theme.image})` : theme.gradient,
              backgroundSize: 'cover',
              cursor: 'pointer',
              border:
                themeId === selectedTheme
                  ? `4px solid ${themeColors[theme.name] || '#6123FF'}`
                  : theme.isLight
                    ? `2px solid #a0a0a0`
                    : 'none',
              transition: 'opacity 0.2s ease, border 0.2s ease, transform 0.2s ease',
              '&:hover': {
                opacity: 1,
                transform: 'scale(1.1)'
              }
            }}
            onClick={() => onThemeChange(themeId)}
          />
        </Grid>
      ))}
    </Grid>
  )
}
